import { takeEvery, select, put } from 'redux-saga/effects';
import {
  revalidateImportRows,
  setImportRows,
  setImportGeoValidationResult,
  setImportDupCheckErrors,
  appNotify
} from 'store/actions';
import { importTypeStateSelector, opportunityImportSelectedChannelSelector, postAcqTaskImportChannelSelector, postAcqTaskImportRequestTypeSelector } from 'store/selectors';
import { ValidateRows } from 'services/importValidationService';
import { Constants } from 'utilities/constants';

const geoFields = ['street', 'city', 'state', 'zipCode'];
const postAcqFields = ['assetId'];

export function* revalidateImportRowsSaga() {
  yield takeEvery(revalidateImportRows, function* ({ payload }) {
    const { importType, rows, isFromRejectedImports } = payload;
    try {
      const importSelectedChannel = importType === Constants.ImportType.OPPORTUNITIES ? yield select(opportunityImportSelectedChannelSelector) : null;
      const postAcqChannel = importType === Constants.ImportType.POSTACQTASKS ? yield select(postAcqTaskImportChannelSelector) : null;
      const postAcqRequestType = importType === Constants.ImportType.POSTACQTASKS ? yield select(postAcqTaskImportRequestTypeSelector) : null;
      const importSource = importType === Constants.ImportType.POSTACQTASKS ? 'ReVUe' : Constants.ImportSource.ManualImport;
      const validatedRows = yield ValidateRows(rows, importSelectedChannel, postAcqChannel, postAcqRequestType, importType, importSource);
      if (!validatedRows) return;

      const actions = [setImportRows({ importType, importRows: validatedRows })];
      if (importType !== Constants.ImportType.TITLES) {
        let fieldChanged = false;
        const importTypeState = yield select(importTypeStateSelector, importType);
        const oldRows = importTypeState.importRows;
        // check if relevant fields changed by comparing old fields with new fields
        const comparisonFields = importType === Constants.ImportType.POSTACQTASKS ? postAcqFields : geoFields;
        for (let row of rows) {
          const foundOldRow = oldRows.find(old => old.referenceId === row.referenceId);
          if (foundOldRow) {
            for (let field of comparisonFields) {
              if (row[field] !== foundOldRow[field]) {
                fieldChanged = true;
                break;
              }
            }
          }
        }
        if (fieldChanged || isFromRejectedImports) { // Disable this if we want to reset geo validation on any field edits, instead of only on geo fields
          if (importType !== Constants.ImportType.POSTACQTASKS) {
            actions.push(setImportGeoValidationResult({
              importType,
              importGeoValidationResult: { passedValidation: null, invalidZipCodes: null, invalidCounties: null, invalidGeo: null, geoValidationDtos: null }
            }));
          }
          actions.push(setImportDupCheckErrors({
            importType,
            dupCheckErrors: []
          }));
        }
      }
      yield put(actions);
    }
    catch (error) {
      yield put(appNotify(error.message, 'error'));
      console.log('revalidateImportRowsSaga', error.message);
    }
  });
}